import {FIELD_TYPE} from "types/enums";
import {ColumnsType} from "antd/es/table";
import config from "./config.json";
const {INPUT, SELECT, DATE} = FIELD_TYPE;

const dataFields = [
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    expand: false,
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày sinh",
    expand: false,
  },
  {
    type: INPUT,
    label: "Số điện thoại ",
    expand: false,
  },

  {
    type: INPUT,
    label: "Địa chỉ",
    expand: false,
  },

  {
    type: SELECT,
    label: "Khu khám",
    expand: false,
  },
  {
    type: SELECT,
    label: "Tra thuốc",
    expand: false,
  },
  {
    type: INPUT,
    label: "Mã khám bệnh",
    expand: true,
  },
  {
    type: INPUT,
    label: "Số BHYT",
    expand: true,
  },
  {
    type: INPUT,
    label: "Triệu chứng",
    expand: true,
  },
  {
    type: SELECT,
    label: "Giới tính",
    expand: true,
  },
  {
    type: INPUT,
    label: "Vị trí BN hiện tại",
    expand: true,
  },
  {
    type: DATE,
    label: "Từ ngày",
    expand: true,
  },
  {
    type: DATE,
    label: "Đến ngày",
    expand: true,
  },
  {
    type: SELECT,
    label: "Trạng thái",
    expand: true,
  },
];
const columns: ColumnsType = [
  {title: "STT", dataIndex: "STT", align: "center"},
  {title: "Mã bệnh nhân", dataIndex: "maBn"},
  {title: "Mã KB", dataIndex: "maKB"},
  {title: "Tên BN", dataIndex: "tenBn"},
  {title: "Giới tính", dataIndex: "gender"},
  {title: "Ngày sinh", dataIndex: "birthday"},
  {title: "Thời gian khám", dataIndex: "timeExam"},
  {title: "Ngày khám", dataIndex: "dateExam"},
  {title: "Tra thuốc", dataIndex: "medicine"},
  {title: "Số BHYT", dataIndex: "ensurance"},
  {title: "Địa chỉ", dataIndex: "addr"},
  {title: "Khu khám", dataIndex: "area"},
  {title: "Trạng thái", dataIndex: "status"},
  {title: "Triệu chứng", dataIndex: "express"},
];
const data = [
  {
    STT: "1",
    key: "1",
    maBn: "1238713",
    maKB: "93_192",
    tenBn: "ABC",
    gender: "Nam",
    birthday: "12/09/1999",
    timeExam: "12:00:00",
    dateExam: "12/09/1999",
    medicine: "1231418915",
    ensurance: "-",
    addr: "-",
    area: "",
    status: "-",
    express: "",
  },
];
var listDuration = new Array();

for (let index = 1; index <= 40; index++) {
  listDuration.push(index.toString());
}

const catalog_2: any = [
  {
    id: "0",
    name: "chiefComplaints",
    title: "Bệnh sử",
    defaultObjects: [
      {label: "Ghi chú", name: "Comments", type: "textArea", xl: 24, row: 2},
    ],
    objects: [],
    components: [
      // {
      //   name: "Name",
      //   title: "Name",
      //   type: "title",
      // },
      // {
      //   name: "Side",
      //   title: "Side",
      //   type: "dropdown",
      // },
      // {
      //   name: "Duration",
      //   title: "Duration",
      //   type: "dropdown",
      // },
      // {
      //   name: "Comments",
      //   title: "Comments",
      //   type: "input",
      // },
      // {
      //   name: "MoreOptions",
      //   title: "More Options",
      //   type: "array_checkbox",
      // },
    ],
  },
  {
    id: "1",
    name: "ophthalmicHistory",
    title: "Tiền sử bệnh nhãn khoa",
    defaultObjects: [
      {label: "Ghi chú", name: "Comments", type: "textArea", xl: 24, row: 2},
    ],
    objects: [],
    components: [
      // {
      //   name: "Name",
      //   title: "Name",
      //   type: "title",
      // },
      // {
      //   name: "LeftDuration",
      //   title: "Left Duration",
      //   type: "dropdown",
      // },
      // {
      //   name: "LeftDurationUnit",
      //   title: "Left Duration Unit",
      //   type: "dropdown",
      // },
      // {
      //   name: "RightDuration",
      //   title: "Right Duration",
      //   type: "dropdown",
      // },
      // {
      //   name: "RightDurationUnit",
      //   title: "Right Duration Unit",
      //   type: "dropdown",
      // },
      // {
      //   name: "Comments",
      //   title: "Comments",
      //   type: "input",
      // },
    ],
  },
  {
    id: "2",
    name: "systemicHistory",
    title: "Tiền sử bệnh toàn thân",
    defaultObjects: [
      {label: "Tiền sử bệnh", name: "MedicalHistory", type: "textArea"},
      {label: "Tiền sử gia đình", name: "FamilyHistory", type: "textArea"},
      {label: "Ghi chú", name: "Comments", type: "textArea"},
    ],
    objects: [],
    components: [],
  },
  {
    id: "3",
    name: "drugAllergies",
    title: "Drug Allergies",
  },
  {
    id: "4",
    name: "contactAllergies",
    title: "Tiền sử dị ứng ",
    defaultObjects: [
      {
        label: "Dị ứng tiếp xúc",
        name: "ContactAllergiesComment",
        type: "textArea",
      },
      {
        label: "Dị ứng thuốc",
        name: "DrugAllergiesComment",
        type: "textArea",
      },
      {
        label: "Dị ứng thực phẩm",
        name: "FoodAllergiesComment",
        type: "textArea",
      },
    ],
    objects: [],
    components: [
      // {
      //   name: "Name",
      //   title: "Name",
      //   type: "title",
      // },
      // {
      //   name: "Duration",
      //   title: "Duration",
      //   type: "dropdown",
      // },
      // {
      //   name: "DurationUnit",
      //   title: "Duration Unit",
      //   type: "dropdown",
      // },
      // {
      //   name: "Comments",
      //   title: "Comments",
      //   type: "input",
      // },
    ],
  },
  {
    id: "5",
    name: "foodAllergies",
    title: "Tiền sử dị ứng thực phẩm",
    defaultObjects: [
      {
        label: "Ghi chú",
        name: "FoodAllergiesComment",
        type: "textArea",
      },
      // {label: "Other", name: "Other", type: "textArea"},
    ],
    objects: [],
    components: [
      // {
      //   name: "Name",
      //   title: "Name",
      //   type: "title",
      // },
      // {
      //   name: "Duration",
      //   title: "Duration",
      //   type: "dropdown",
      // },
      // {
      //   name: "DurationUnit",
      //   title: "Duration Unit",
      //   type: "dropdown",
      // },
      // {
      //   name: "Comments",
      //   title: "Comments",
      //   type: "input",
      // },
    ],
  },
  {
    id: "6",
    name: "foodAllergies",
    title: "Ghi chú khác",
    defaultObjects: [
      {
        label: "Ghi chú",
        name: "Comment",
        type: "textArea",
      },
      // {label: "Other", name: "Other", type: "textArea"},
    ],
    objects: [],
    components: [],
  },
];
let listObjectChiefComplaint: any = [
  // {name: "Blurring", title: "Blurring"},
  // {name: "Redness", title: "Redness"},
  // {name: "Pain", title: "Pain"},
  // {name: "Injury/Trauma", title: "Injury/Trauma"},
  // {name: "Watering", title: "Watering"},
  // {name: "Dischard", title: "Dischard"},
  // {name: "Dryness", title: "Dryness"},
  // {name: "Itching", title: "Itching"},
  // {name: "FBsensation", title: "FBsensation"},
  // {name: "Deviation/Squint", title: "Deviation/Squint"},
  // {name: "Headache/Strain", title: "Headache/Strain"},
  // {name: "ChangeInSize/Shape", title: "Change in Size/Shape"},
  // {name: "OtherVisualSymptoms", title: "Other Visual Symptoms"},
  // {name: "Shadow/DefectInVision", title: "Shadow/Defect in vision"},
];
let listObjectOphthalmicHistory: any = [
  // {name: "RetinalDetachment", title: "Retinal Detachment"},
  // {name: "Glasses", title: "Glasses"},
  // {name: "EyeDisease", title: "Eye Disease"},
  // {name: "EyeSurgery", title: "Eye StandardWorkMonth"},
  // {name: "Uveitis", title: "Uveitis"},
  // {name: "RetinalLaser", title: "Retinal Laser"},
  // {name: "ContactLens", title: "Contact Lens"},
  // {name: "Glaucoma", title: "Glaucoma"},
];
let listObjectSystemic: any = [
  // {name: "Diabetes", title: "Diabetes"},
  // {name: "Hypertension", title: "Hypertension"},
  // {name: "Alcoholism", title: "Alcoholism"},
  // {name: "SmokingTobacco", title: "Smoking Tobacco"},
  // {name: "CardiacDisorder", title: "Cardiac Disorder"},
  // {name: "SteroidIntake", title: "Steroid Intake"},
  // {name: "DrugAbuse", title: "Drug Abuse"},
  // {name: "HivAids", title: "Hiv Aids"},
  // {name: "CancerTumor", title: "Cancer Tumor"},
  // {name: "Tuberculosis", title: "Tuberculosis"},
  // {name: "Asthma", title: "Asthma"},
  // {name: "CnsDisorderStroke", title: "Cns Disorder Stroke"},
  // {name: "Hypothyroidism", title: "Hypothyroidism"},
  // {name: "HepatitisCirrhosis", title: "Hepatitis Cirrhosis"},
  // {name: "RenalDisorder", title: "Renal Disorder"},
  // {name: "Acidity", title: "Acidity"},
  // {name: "OnInsulin", title: "On insulin"},
  // {name: "OnAspirinBloodThinners", title: "On Aspirin Blood Thinners"},
  // {name: "Consanguinity", title: "Consanguinity"},
  // {name: "ThyroidDisorder", title: "Thyroid Disorder"},
  // {name: "ChewingTobacco", title: "Chewing Tobacco"},
  // {name: "ChronicKidneyDisease", title: "Chronic Kidney Disease"},
  // {name: "CVA", title: "CVA"},
  // {name: "RheumatoidArthritis", title: "Rheumatoid Arthritis"},
  // {
  //   name: "BenignProstatic Hyperplasia(BPH)",
  //   title: "Benign Prostatic Hyperplasia(BPH)",
  // },
];
let listObjectContactAllergies: any = [
  // {name: "Alcohol", title: "Alcohol"},
  // {name: "Latex", title: "Latex"},
  // {name: "Betadine", title: "Betadine"},
  // {name: "AdhesivesTape", title: "Adhesive Tape"},
  // {name: "Tegaderm", title: "Tegaderm"},
  // {name: "Transpore", title: "Transpore"},
];
let listObjectFoodAllergies: any = [
  // {name: "AllSeafood", title: "All Seafood"},
  // {name: "Mushroom", title: "Mushroom"},
  // {name: "Lactose", title: "Lactose"},
  // {name: "ShellfishOnly", title: "Shellfish Only"},
  // {name: "Peanuts", title: "Peanuts"},
  // {name: "MilkProteins", title: "Milk Proteins"},
  // {name: "Egg", title: "Egg"},
  // {name: "Corn", title: "Corn"},
  // {name: "SoyProtein", title: "Soy Protein"},
];
catalog_2[0].objects = listObjectChiefComplaint.map((e, index) => {
  e = {
    ...e,
    components: [
      // {
      //   name: "Name",
      //   title: "Name",
      //   type: "",
      // },
      // {
      //   name: "Side",
      //   title: "Side",
      //   type: "dropdown",
      //   values: ["L", "R", "B/E"],
      // },
      // {
      //   name: "Duration",
      //   title: "Duration",
      //   type: "dropdown",
      //   values: listDuration,
      // },
      // {
      //   name: "Comments",
      //   title: "Comments",
      //   type: "input",
      // },
      // {
      //   name: "MoreOptions",
      //   title: "More Options",
      //   type: "array_checkbox",
      //   values: [],
      // },
    ],
  };
  if (index == 0) {
    e.components[4].values = ["Distant", "Near", "Pain", "UsingGlasses"];
  }
  if (index == 3) {
    e.components[4].type = "other";
    e.components[4].otherType = {
      name: "DateInjury",
      title: "Date Injury",
      type: "date",
    };
  }
  return e;
});
catalog_2[1].objects = listObjectOphthalmicHistory.map(e => {
  return {
    ...e,
    components: [
      // {
      //   name: "Name",
      //   title: "Name",
      //   type: "",
      // },
      // {
      //   name: "LeftDuration",
      //   title: "Left Duration",
      //   type: "dropdown",
      //   values: listDuration,
      // },
      // {
      //   name: "LeftDurationUnit",
      //   title: "Left Duration Unit",
      //   type: "dropdown",
      //   values: ["Days", "Weeks", "Months", "Years"],
      // },
      // {
      //   name: "RightDuration",
      //   title: "Right Duration",
      //   type: "dropdown",
      //   values: listDuration,
      // },
      // {
      //   name: "RightDurationUnit",
      //   title: "Right Duration Unit",
      //   type: "dropdown",
      //   values: ["Days", "Weeks", "Months", "Years"],
      // },
      // {
      //   name: "Comments",
      //   title: "Comments",
      //   type: "input",
      // },
    ],
  };
});
catalog_2[2].objects = listObjectSystemic.map(e => {
  return {
    ...e,
    components: [
      // {
      //   name: "Name",
      //   title: "Name",
      //   type: "",
      // },
      // {
      //   name: "Duration",
      //   title: "Duration",
      //   type: "dropdown",
      //   values: listDuration,
      // },
      // {
      //   name: "DurationUnit",
      //   title: "Duration Unit",
      //   type: "dropdown",
      //   values: ["Days", "Weeks", "Months", "Years"],
      // },
      // {
      //   name: "Comments",
      //   title: "Comments",
      //   type: "input",
      // },
      // {
      //   name: "MoreOptions",
      //   title: "More Options",
      //   type: "array_checkbox",
      //   values: [],
      // },
    ],
  };
});
catalog_2[4].objects = listObjectContactAllergies.map(e => {
  return {
    ...e,
    components: [
      // {
      //   name: "Name",
      //   title: "Name",
      //   type: "",
      // },
      // {
      //   name: "Duration",
      //   title: "Duration",
      //   type: "dropdown",
      //   values: listDuration,
      // },
      // {
      //   name: "DurationUnit",
      //   title: "Duration Unit",
      //   type: "dropdown",
      //   values: ["Days", "Weeks", "Months", "Years"],
      // },
      // {
      //   name: "Comments",
      //   title: "Comments",
      //   type: "input",
      // },
    ],
  };
});
catalog_2[5].objects = listObjectFoodAllergies.map(e => {
  return {
    ...e,
    components: [
      // {
      //   name: "Name",
      //   title: "Name",
      //   type: "",
      // },
      // {
      //   name: "Duration",
      //   title: "Duration",
      //   type: "dropdown",
      //   values: listDuration,
      // },
      // {
      //   name: "DurationUnit",
      //   title: "Duration Unit",
      //   type: "dropdown",
      //   values: ["Days", "Weeks", "Months", "Years"],
      // },
      // {
      //   name: "Comments",
      //   title: "Comments",
      //   type: "input",
      // },
    ],
  };
});
// catalog_2[2].objects.find(
//   e => e.name == "CardiacDisorder"
// ).components[4].values = [
//   "Myocardial Infarcrtion",
//   "Coronary artery bypass graft",
//   "Permanent Pacemaker",
// ];

export {dataFields, columns, data, config, catalog_2};
